<!-- 审核业务员详情弹窗 -->
<template>
  <div class="detail-root">
    <el-dialog
      title="查看业务员"
      :close-on-click-modal="false"
      :visible.sync="dialogVisible"
      width="618px"
      @closed="onClosed"
      v-loading="loading"
      top="10vh"
    >
      <div class="content form-content" v-if="dialogVisible">
        <!-- 业务员类型 内部业务员 第三方业务员-->
        <div class="row mutlti big">
          <div class="tip"><span class="point">*</span>业务员类型</div>
          <div class="value input" style="margin-top: 8px">
            <el-radio-group v-model="formData.type" :disabled="isLook">
              <el-radio label="0">内部业务员</el-radio>
              <el-radio label="1">第三方业务员</el-radio>
            </el-radio-group>
            <div class="value-desc"></div>
          </div>
        </div>
        <div class="row mutlti big">
          <div class="tip"><span class="point">*</span>业务员姓名</div>
          <div class="value input">
            <el-input
              size="small"
              maxlength="20"
              v-model="formData.name"
              placeholder="请输入姓名"
              :disabled="isLook"
            ></el-input>
          </div>
        </div>
        <div class="row mutlti big">
          <div class="tip"><span class="point">*</span>业务员身份证</div>
          <div class="value input">
            <el-input
              size="small"
              maxlength="20"
              v-model="formData.idCard"
              placeholder="请输入"
              :disabled="isLook"
            ></el-input>
          </div>
        </div>
        <div class="row mutlti big">
          <div class="tip"><span class="point">*</span>业务员账号</div>
          <div class="value input">
            <el-input
              size="small"
              maxlength="20"
              v-model="formData.userTel"
              :disabled="isLook"
              placeholder="请输入账号"
            ></el-input>
            <div class="value-desc">
              请输入手机号，手机号将作为业务员登录系统的账号
            </div>
          </div>
        </div>
        <div class="row mutlti big">
          <div class="tip"><span class="point">*</span>业务员身份信息</div>
          <div class="value input">
            <ossFileUpload
              key="1"
              ref="refUserFileUpload"
              v-model="userFiles"
              :limit="3"
              :accept="picFileExt"
              :maxFileLength="10"
              :ossUpload="true"
              :ossPathDir="'shop/pic/'"
              style="margin-bottom: 10px"
              :disabled="isLook"
              :listType="'picture-card'"
            >
            </ossFileUpload>
            <div class="small-tip warning" v-if="!isLook">
              <span
                >请上传业务员身份证正反面。格式要求：pdf或图片，且不超过10M，最多上传3个。上传多个文件时，将按文件上传的顺序给业务员展示资料</span
              >
            </div>
          </div>
        </div>
        <div class="row mutlti big" v-show="formData.type === '0'">
          <div class="tip"><span class="point">*</span>业务员签约信息</div>
          <div class="value input">
            <ossFileUpload
              key="2"
              ref="refContractFileUpload"
              v-model="contractFiles"
              :limit="5"
              :accept="picFileExt"
              :maxFileLength="10"
              :ossUpload="true"
              :ossPathDir="'shop/pic/'"
              style="margin-bottom: 10px"
              :disabled="isLook"
              :listType="'picture-card'"
            >
            </ossFileUpload>
            <div class="small-tip warning" v-if="!isLook">
              <span
                >请上传业务员合同信息。格式要求：上传pdf或图片，且不超过10M，最多上传5个。上传多个文件时，将按文件上传的顺序给业务员展示资料</span
              >
            </div>
          </div>
        </div>
        <div class="row mutlti big" v-show="formData.type === '1'">
          <div class="tip"><span class="point">*</span> 雇佣凭证</div>
          <div class="value input">
            <ossFileUpload
              key="4"
              ref="refEmployeeFileUpload"
              v-model="employeeFiles"
              :limit="5"
              :accept="picFileExt"
              :maxFileLength="10"
              :ossUpload="true"
              :ossPathDir="'shop/pic/'"
              style="margin-bottom: 10px"
              :disabled="isLook"
              :listType="'picture-card'"
            >
            </ossFileUpload>
            <div class="small-tip warning" v-if="!isLook">
              <span
                >请上传完税凭证；。格式要求：上传pdf或图片，且不超过10M，最多上传5个。上传多个文件时，将按文件上传的顺序给业务员展示资料</span
              >
            </div>
          </div>
        </div>
        <div class="row mutlti big">
          <div class="tip">其他上传材料</div>
          <div class="value input">
            <ossFileUpload
              key="3"
              ref="refOtherFileUpload"
              v-model="otherFiles"
              :limit="5"
              :accept="picFileExt"
              :maxFileLength="10"
              :ossUpload="true"
              :ossPathDir="'shop/pic/'"
              style="margin-bottom: 10px"
              :disabled="isLook"
              :listType="'picture-card'"
            >
            </ossFileUpload>
            <div class="small-tip warning" v-if="!isLook">
              <span
                >请上传其他材料。格式要求：上传pdf或图片，且不超过10M，最多上传5个。上传多个文件时，将按文件上传的顺序给业务员展示资料</span
              >
            </div>
          </div>
        </div>
        <!-- 审核结果 通过 驳回 -->
        <div class="row mutlti big" v-if="isCheck">
          <div class="tip"><span class="point">*</span>审核结果</div>
          <div class="value input" style="margin-top: 8px">
            <el-radio-group v-model="formData.auditStatus" :disabled="!isCheck">
              <el-radio label="1">通过</el-radio>
              <el-radio label="2">驳回</el-radio>
            </el-radio-group>
            <div class="value-desc"></div>
          </div>
        </div>
        <!-- 驳回原因-->
        <div
          class="row mutlti big"
          v-if="isCheck && formData.auditStatus === '2'"
        >
          <div class="tip"><span class="point">*</span>驳回原因</div>
          <div class="value input" style="margin-top: 8px">
            <el-input
              type="textarea"
              v-model="formData.rejectReason"
              :disabled="!isCheck"
              placeholder="请输入驳回原因"
            ></el-input>
            <div class="value-desc"></div>
          </div>
        </div>
        <!-- 审核历史 -->
        <div
          class="row mutlti big"
          v-if="rejectHistory && rejectHistory.length > 0"
        >
          <div class="tip"><span class="point">*</span>审核历史</div>
          <div class="value input" style="margin-top: 8px">
            <el-timeline :reverse="true">
              <el-timeline-item
                v-for="(activity, index) in rejectHistory"
                :key="index"
                :timestamp="activity.createTime"
              >
                <span>【{{ activity.createBy }}】</span>
                <span>{{
                  activity.auditStatus === 1 ? "通过" : "驳回："
                }}</span>
                <span>{{ activity.rejectReason || "" }}</span>
              </el-timeline-item>
            </el-timeline>
            <div class="value-desc"></div>
          </div>
        </div>
      </div>
      <div slot="footer" class="dialog-footer" v-if="isCheck">
        <el-button type="default" size="small" @click="close">取 消</el-button>
        <el-button
          type="primary"
          size="small"
          :loading="submitLoading"
          @click="submitCheck"
          v-if="isCheck"
        >
          保 存
        </el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { cloneDeep } from "lodash";
import {
  csoMemberDetail,
  auditCsoMember,
} from "@/api/compliance/checkSalesman";
import ossFileUpload from "@/components/ossFileUpload";
export default {
  components: {
    ossFileUpload,
  },
  data() {
    return {
      action: 1, //1 新增  2 编辑 3 查看
      dialogVisible: false,
      mainId: null,
      loading: false,
      formData: {
        name: "",
        userTel: "",
        idCard: "",
        type: "0",
        auditStatus: "0", //{ 0: "待审核", 1: "审核通过", 2: "审核不通过" },
      },
      memberInfo: null,
      userFiles: [], // 身份证列表
      contractFiles: [], // 签约信息列表
      employeeFiles: [], // 雇佣凭证列表
      otherFiles: [], // 其他材料
      picFileExt: ".jpg,.png,.pdf,.jpeg",
      isLook: true, //审核 or 查看
      isCheck: false, //是否可以审核
      submitLoading: false,
      rejectHistory: [], // 驳回历史
    };
  },
  watch: {
    "formData.auditStatus": {
      handler(val) {
        this.formData.rejectReason = "";
      },
      immediate: true,
    },
  },
  computed: {
    isReject() {
      return this.formData && this.formData.auditStatus === "2";
    },
  },
  methods: {
    submitCheck() {
      this.submitLoading = true;
      let params = cloneDeep(this.formData);
      params.id = this.mainId;
      if (params.auditStatus === "2" && !params.rejectReason) {
        this.$message.error("驳回原因不能为空");
        this.submitLoading = false;
        return;
      }
      auditCsoMember(params)
        .then((res) => {
          if (res) {
            this.$message.success("保存成功");
            this.close();
            this.$emit("refresh");
          } else {
            this.$message.error("保存失败");
          }
        })
        .finally(() => {
          this.submitLoading = false;
        });
    },
    open(options = null) {
      if (options) {
        const { action, row } = options;
        this.isCheck = action; //
        if (row && row.id) {
          this.mainId = row.id;
          this.getDetail();
        }
      }
      this.dialogVisible = true;
      this.$nextTick(() => {
        this.$refs.refUserFileUpload.init(); //初始化oss上传
        this.$refs.refContractFileUpload.init(); //初始化oss上传
        this.$refs.refOtherFileUpload.init(); //初始化oss上传
        this.$refs.refEmployeeFileUpload.init(); //初始化oss上传
      });
    },
    close() {
      this.dialogVisible = false;
    },
    onClosed() {
      this.reset();
    },
    reset() {
      this.action = 1;
      this.mainId = "";
      this.formData = {
        name: "",
        userTel: "",
        idCard: "",
        type: "0",
        auditStatus: "0",
        rejectReason: "",
      };
      this.memberInfo = null;
      this.userFiles = [];
      this.contractFiles = [];
      this.employeeFiles = [];
      this.otherFiles = [];
      this.loading = false;
    },
    getDetail() {
      if (this.mainId) {
        this.loading = true;
        csoMemberDetail(this.mainId)
          .then((data) => {
            if (data) {
              this.formData = {
                name: data.name || "",
                userTel: data.userTel || "",
                idCard: data.idCard || "",
                type: data.type ? data.type.toString() : "0",
                auditStatus: data.auditStatus.toString() || "0",
                rejectReason: "",
              };
              this.rejectHistory = data.csoMemberAuditLogDetailVOS || [];
              this.memberInfo = data;
              let filesData = data.csoMemberAttachAddQOS;
              if (filesData && filesData.length > 0) {
                this.userFiles = filesData
                  .filter((li) => li.attachType == 1)
                  .map((li) => {
                    return this.parseToUploadUrl(li);
                  });
                this.contractFiles = filesData
                  .filter((li) => li.attachType == 2)
                  .map((li) => {
                    return this.parseToUploadUrl(li);
                  });
                this.otherFiles = filesData
                  .filter((li) => li.attachType == 3)
                  .map((li) => {
                    return this.parseToUploadUrl(li);
                  });
                this.employeeFiles = filesData
                  .filter((li) => li.attachType == 4)
                  .map((li) => {
                    return this.parseToUploadUrl(li);
                  });
              }
            }
          })
          .finally(() => {
            this.loading = false;
          });
      }
    },
    getUploadFileUrl(item, type = 1) {
      let netUrl = "";
      if (item) {
        if (item.url) {
          //可能是已经上传过的
          netUrl = item.url;
        } else if (
          //服务器返回过来的
          item.response &&
          item.response.data &&
          item.response.data.url
        ) {
          netUrl = item.response.data.url;
        }
      }
      // attachType 1 身份证 2 签约信息 3 其他材料 4 外部业务员：雇佣凭证
      return { attachName: item.name, attachUrl: netUrl, attachType: type };
    },
    parseToUploadUrl(el) {
      const { attachUrl, attachName } = el;
      // attachUrl 取最后一个.后面的字符串 作为文件类型
      if (attachUrl) {
        const reg = /(\.\w+)$/;
        const type = reg.exec(attachUrl)[1];
        // return { name: attachName, url: attachUrl, type };
        const paddName = type ? attachName + type : attachName;
        return { name: paddName, url: attachUrl };
      }
      return { name: attachName, url: "" };
    },
  },
};
</script>

<style lang="scss" scoped>
.detail-root {
  .form-content {
    overflow-y: auto;
    .row {
      display: flex;
      flex-direction: row;
      align-items: center;
      padding: 8px 0;
      box-sizing: border-box;
      &.mutlti {
        align-items: flex-start;
      }
      &.big {
        .tip {
          height: 32px;
          line-height: 32px;
        }
      }
      .tip {
        width: 8em;
        text-align: right;
        font-size: 14px;
        font-weight: 400;
        text-align: right;
        color: #262626;
        span.point {
          color: #f00;
          margin-right: 2px;
        }
      }
      .value {
        margin-left: 16px;
        &-desc {
          line-height: 1;
          margin-top: 6px;
          color: #8c8c8c;
          font-size: 13px;
        }
        &.input {
          width: calc(100% - 200px);
        }
        &.fill {
          flex: 1;
          width: 0;
        }
        .small-tip {
          font-size: 14px;
          font-weight: 400;
          text-align: left;
          color: #8c8c8c;
          &.warning {
            color: #e6a23c;
          }
        }
        &.mutlti {
          flex: 1;
          width: 0;
          display: flex;
        }
      }
    }
  }
  ::v-deep .el-dialog__body {
    height: 70vh;
    overflow-y: auto;
    min-height: 240px;
  }
}
</style>
